<div class="navmenu" id="navmenu">
  <div
    class="page-overlay"
    (click)="toggleMenu()"
    (keydown.escape)="toggleMenu()"
    tabindex="0"
    role="button"
    aria-label="Close navigation menu"
    [ngClass]="{
      'page-overlay--visible': isOverlayOpen
    }"></div>
  <div
    class="navmenu__content"
    [ngClass]="{
      'navmenu__content--open': isOverlayOpen
    }"
    #navmenuContent
    role="navigation"
    aria-label="Main navigation">
    <a [routerLink]="['/']" class="navmenu__link" #homeLink>Home</a>
    <a [routerLink]="['calendar']" class="navmenu__link" #calendarLink>Birthday Calendar</a>
    <a [routerLink]="['calendar/submit']" class="navmenu__link" #submitLink>Submit a Birthday</a>
    <a [routerLink]="['about']" class="navmenu__link" #aboutLink>About</a>
    <a [routerLink]="['contact']" class="navmenu__link" #contactLink>Contact</a>
  </div>
  <button
    class="navmenu__icon"
    (click)="toggleMenu()"
    #menuButton
    [attr.aria-label]="isOverlayOpen ? 'Close navigation menu' : 'Open navigation menu'"
    [attr.aria-expanded]="isOverlayOpen"
    aria-controls="navmenu">
    <fa-icon [icon]="faBars" aria-hidden="true" />
  </button>
</div>
